(() => {
  const parseSection = (html, selector) => {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  };

  const updateSection = (sectionHtml, targetSelector, sourceSelector) => {
    const target = document.querySelector(targetSelector);
    const source = parseSection(sectionHtml, sourceSelector);
    if (target && source) target.innerHTML = source.innerHTML;
  };

  const addVariant = async (button) => {
    const variantId = Number(button.dataset.variantId);
    if (!variantId || button.classList.contains('is-loading')) return;

    const motivator = button.closest('[data-kk-shipping-motivator]');
    const originalText = button.querySelector('span')?.textContent || '+ Add';
    const error = motivator?.querySelector('[data-kk-shipping-error]');

    button.classList.add('is-loading');
    button.setAttribute('aria-disabled', 'true');
    if (button.querySelector('span')) button.querySelector('span').textContent = motivator?.dataset.kkLoading || 'Adding…';
    if (error) error.hidden = true;

    try {
      const response = await fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'],
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state.status) {
        throw new Error(state.description || state.message || motivator?.dataset.kkError || 'The product could not be added.');
      }

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(state);
      } else {
        updateSection(state.sections?.['cart-icon-bubble'], '#cart-icon-bubble', '.shopify-section');
      }

      updateSection(state.sections?.['main-cart-items'], '#main-cart-items .js-contents', '.js-contents');
      updateSection(state.sections?.['main-cart-footer'], '#main-cart-footer .js-contents', '.js-contents');

      if (window.publish && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'kk-shipping-motivator',
          productVariantId: String(variantId),
          cartData: state,
        });
      }
    } catch (requestError) {
      if (error) {
        error.textContent = requestError.message;
        error.hidden = false;
      }
      button.classList.remove('is-loading');
      button.removeAttribute('aria-disabled');
      if (button.querySelector('span')) button.querySelector('span').textContent = originalText;
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kk-quick-add]');
    if (button) addVariant(button);
  });
})();
